import { Controller } from "@hotwired/stimulus";

// Affiche/masque des groupes de champs selon la valeur d'un select.
// Chaque groupe porte data-show-for="valeur1 valeur2". Utilisé par les builders
// d'automatisation (déclencheur + actions).
export default class extends Controller {
  static targets = ["select", "group"];

  connect() {
    this.refresh();
  }

  refresh() {
    const value = this.hasSelectTarget ? this.selectTarget.value : null;
    this.groupTargets.forEach((group) => {
      const showFor = (group.dataset.showFor || "").split(/\s+/).filter(Boolean);
      group.hidden = !showFor.includes(value);
    });
  }
}
